import { FormulateType } from './types'

/**
 * 获取基础公式 keys labels
 *
 * @returns 基础公式 keys & labels
 */
export const getBasicItemTypes: () => FormulateType[] = () => [
  { key: 'basic', label: '常用符号' },
  { key: 'trig', label: '三角函数' },
  { key: 'greek', label: '希腊字母' },
  { key: 'differential', label: '分数微分' },
  { key: 'radical', label: '根式角标' },
  { key: 'extremity', label: '极限对数' },
]

/**
 * 获取公式模板 keys labels
 *
 * @returns 公式模板 keys & labels
 */
export const getTemplateTypes: () => FormulateType[] = () => [
  { key: 'algebra', label: '代数' },
  { key: 'geometric', label: '几何' },
  { key: 'inequality', label: '不等式' },
  { key: 'trig', label: '三角函数' },
  // 更多模板 todo
  /*
   * { key: 'integral', label: $t('积分') },
   * { key: 'statistical', label: $t('统计') },
   * { key: 'sequence', label: $t('数列') },
   * { key: 'physical', label: $t('物理') },
   * { key: 'chemical', label: $t('化学') },
   */
]
